import { render, staticRenderFns } from "./imageMulti.vue?vue&type=template&id=f328c764&scoped=true&"
import script from "./imageMulti.vue?vue&type=script&lang=js&"
export * from "./imageMulti.vue?vue&type=script&lang=js&"
import style0 from "./imageMulti.vue?vue&type=style&index=0&id=f328c764&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f328c764",
  null
  
)

export default component.exports